<template>
    <v-dialog v-model="exibeModal" width=1000 persistent>
        <v-card>
            <v-card-title
                class="body-2 font-weight-bold primary white--text"
                primary-title>
                Mais Detalhes
                <v-spacer/>
                <v-btn icon small dark @click="fecharModalAjuste">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="1" class="siglaCol">
                        <v-tooltip top nudge-top="-3" max-width="800" open-delay="500">
                            <template v-slot:activator="{ on }">
                                <div v-on="on" class="iconeCard d-flex justify-center align-center">
                                    <span class="textoTitulo font-weight-bold">A</span>
                                </div>
                            </template>
                            <span>Ajuste</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="2" class="mt-2 px-0">
                        <span class="font-weight-bold titulo">{{ajuste.tipo}}</span>
                    </v-col>
                    <v-col cols="2">
                        <span class="font-weight-bold">Órgão</span>
                        <p class="mb-0">{{ajuste.orgao}}</p>
                    </v-col>
                    <v-col cols="3">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <div v-on="on">
                            <span class="font-weight-bold">Conta Contábil</span>
                            <p class="mb-0 campo-conta-contabil">
                              {{ ajuste.contaContabil }}
                            </p>
                          </div>
                        </template>
                        <span>{{ ajuste.contaContabil }}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="2">
                        <span class="font-weight-bold">Finalizado por</span>
                        <p class="mb-0">{{ajuste.usuarioFinalizacao}}</p>
                    </v-col>
                    <v-col cols="2">
                        <span class="font-weight-bold">Finalizado em</span>
                        <p class="mb-0">{{ajuste.dataFinalizacao | azDate }}</p>
                    </v-col>
                </v-row>
                <v-divider/>
                <v-row>
                    <v-col cols="2" class="mt-2 mb-0 pb-0">
                        <span class="font-weight-bold titulo">DE</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <span class="font-weight-bold">Valor de Entrada</span>
                        <p>{{ajuste.valorEntradaAnterior | valorParaDinheiro}}</p>
                    </v-col>
                    <v-col cols="2">
                        <span class="font-weight-bold">Valor Liquído</span>
                        <p>{{ajuste.valorLiquidoAnterior | valorParaDinheiro}}</p>
                    </v-col>
                    <v-col cols="2">
                        <span class="font-weight-bold">Valor Bruto</span>
                        <p>{{ajuste.valorBrutoAnterior | valorParaDinheiro}}</p>
                    </v-col>
                    <v-col>
                        <span class="font-weight-bold">Período Licença</span>
                        <p>{{ajuste.periodoLicenca}}</p>
                    </v-col>
                </v-row>
                <v-divider/>
                <v-row>
                    <v-col cols="2" class="pb-0">
                        <span class="font-weight-bold titulo">PARA</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <span class="font-weight-bold">Valor de Entrada</span>
                        <p class="mb-0">{{ajuste.valorEntradaPosterior | valorParaDinheiro}}</p>
                    </v-col>

                    <v-col cols="2" v-if="!ehAjusteReducaoAoValorRecuperavel">
                        <span class="font-weight-bold">Valor Acrescido</span>
                        <p class="mb-0">{{ajuste.valorAcrescido | valorParaDinheiro}}</p>
                    </v-col>

                    <v-col cols="2" v-if="ehAjusteReducaoAoValorRecuperavel">
                        <span class="font-weight-bold">Valor Reduzido</span>
                        <p class="mb-0">{{ajuste.impairment | valorParaDinheiro}}</p>
                    </v-col>

                    <v-col cols="2">
                        <span class="font-weight-bold">Novo Valor Líquido</span>
                        <p class="mb-0">{{ajuste.valorLiquidoPosterior | valorParaDinheiro}}</p>
                    </v-col>

                    <v-col cols="2">
                        <span class="font-weight-bold">Novo Valor Bruto</span>
                        <p class="mb-0">{{ajuste.valorBrutoPosterior | valorParaDinheiro}}</p>
                    </v-col>

                    <v-col>
                        <span class="font-weight-bold">Período Licença</span>
                        <p class="mb-0">{{ajuste.periodoLicenca}}</p>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-flex class="row pa-3 ma-0">
                    <v-btn color="grey" text outlined width="150" class="text-body-2"
                           @click="fecharModalAjuste">
                        Voltar
                    </v-btn>
                    <v-spacer/>
                    <v-spacer/>
                    <v-btn
                        @click="acessarVisualizacao"
                        depressed
                        width="150"
                        class="text-body-2"
                        color="primary">
                        Ver Mais
                    </v-btn>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapActions} from 'vuex'
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'
    import {actionTypes, tipoAjuste} from '@/core/constants'

    export default {
        name: 'ModalAjusteDetalhes',
        $_veeValidate: {
            validator: 'new',
        },
        data() {
            return {
                exibeModal: true,
                ajuste: {}
            }
        },
        computed: {
            verificaPermissaoEdicao() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
            },
            ehAjusteReducaoAoValorRecuperavel() {
                return this.ajuste.tipo === tipoAjuste.REDUCAO_AO_VALOR_RECUPERAVEL
            },
        },
        async mounted() {
            this.ajuste = await this.buscarAjustePorId(this.$route.params.ajusteId)
        },
        methods: {
            ...mapActions([
                actionTypes.AJUSTE.BUSCAR_AJUSTE_POR_ID
            ]),
            fecharModalAjuste() {
                this.$emit('fecharModalAjuste')
            },
            acessarVisualizacao() {
                this.$emit('acessarVisualizacao', this.ajuste)
            }
        }
    }
</script>

<style lang="stylus">
    .titulo
        color #0067A5

    .campo-conta-contabil
        overflow hidden
        text-overflow ellipsis
        white-space nowrap

    .siglaCol
        align-content: end
        cursor: default
</style>
